import { computed } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import {RootState} from "@/store";

export function useRouteAccess() {
  const route = useRoute()
  const store = useStore<RootState>()

  // Route access logic
  const isAdminPanel = computed(() => route.path.includes('/admin', 0))
  const routeAccess = computed(() => route.meta.access || 'guest')
  const isGuestRoute = computed(() => routeAccess.value === 'guest')
  const isAdminRoute = computed(() => routeAccess.value === 'admin')
  const isUserRoute = computed(() => routeAccess.value === 'user')

  // User-related computed properties
  const user = computed(() => store.state.auth.user)
  const idUser = computed(() => user.value.idUser)
  const isAdmin = computed(() => user.value.admin)

  // Session and email confirmation logic
  const isSessionInit = computed(() => user.value.idUser !== 0)
  const isUserEmailConfirm = computed(() => user.value.confirmEmail && !store.state.auth.welcomeScreen)

  return {
    // Route properties
    isAdminPanel,
    routeAccess,
    isGuestRoute,
    isAdminRoute,
    isUserRoute,
    
    // User properties
    user,
    idUser,
    isAdmin,
    
    // Session properties
    isSessionInit,
    isUserEmailConfirm,
  }
} 